import { render, staticRenderFns } from "./CgsbwhBrowse.vue?vue&type=template&id=7ae3c83e"
import script from "./CgsbwhBrowse.vue?vue&type=script&lang=js"
export * from "./CgsbwhBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports